import { MediaType } from "@front/m19-api-client";

export function isVideo(mediaType: MediaType) {
  return mediaType === MediaType.videoAsset;
}
